<template>
  <div>
    <el-card
          shadow="always"
          class="d-print-none"
          style="background-color: #d4e2f8; overflow: initial"
        >
          <div style="margin: -10px -10px">
            <el-button size="medium" type="primary" plain @click="callCSVDownload(downloadCSVMethod)">Download CSV</el-button>
            <el-button style="margin-left: 0px;" size="medium" type="primary" plain @click="downloadPDF()">Download PDF</el-button>
            <el-button v-if="showToggleDetails" style="margin-left: 0px;" @click="toggleDetails()" size="medium" type="primary" plain>Toggle Details</el-button>
            <el-select
              v-if="tableColumns"
              v-model="tableColumns"
              @change="$root.$emit('columnChanged', tableColumns)"
              size="medium"

              multiple
              collapse-tags
              style="margin-left: 0px; width: 180px;"
              placeholder="Visible Columns">
              <el-option
                v-for="item in fields"
                :key="item.key"
                :label="item.label"
                :value="item.key">
              </el-option>
            </el-select>
            <!-- <el-upload
              :show-file-list="false"
              :on-change="handleChange"
              ref="upload"
              action="#"
              :auto-upload="false">
              <el-button style="margin-left: 0px;" slot="trigger" size="medium" type="primary">upload products</el-button>
              
            </el-upload> -->
          </div>
          </el-card>
          <SavePDF style="display: none" :items="[]" />
  </div>
</template>

<script>
import SavePDF from "./SavePDF.vue";
import exportFromJSON from 'export-from-json'
import readXlsxFile from 'read-excel-file'
import readSheetNames from 'read-excel-file'
import firebase from "firebase/app";
const fileName = 'download'
const exportType = 'csv'
export default {
  components: { SavePDF},
  props: ["items","perPage","pageOptions","visibleFields","fields","month", "downloadCSVMethod","enableToggle", 'shops'],
  data() {
    return {
      tableColumns: [],
      showToggleDetails: false,
      userDisplayName: firebase.auth().currentUser.displayName,
    }
  },
  created() {
    this.tableColumns = this.visibleFields;
    this.showToggleDetails = this.enableToggle
  },

  computed: {
    // visibleFields() {
     
    // }
  },

  methods: {
    handleChange(file, fileList) {
      // this.fileList.push(file);
      console.log(file, fileList)
      const schema = {
        'name': {
          // JSON object property name.
          prop: 'name',
          type: String
        },
        'barcode/SKU': {
          prop: 'barcode',
          type: String,
          required: true
        },
        'serial No': {
          prop: 'serial',
          type: String,
        },
        'store': {
          prop: 'store',
          type: String,
          required: true
        },
        'category': {
          prop: 'category',
          type: String,
          required: true
        },
        'sub category': {
          prop: 'subCategory',
          type: String,
          required: true
        },
        'cost': {
          prop: 'cost',
          type: Number,
          required: true
        },
        'selling price': {
          prop: 'price',
          type: Number,
          required: true
        },
        'quantity': {
          prop: 'quantity',
          type: Number,
          required: true
        },
        'low alert quantity': {
          prop: 'lowalertquantity',
          type: Number,
          required: true
        },
      }
      readSheetNames(file.raw).then((sheetNames) => {
        console.log('sheetNames',sheetNames)
        readXlsxFile(file.raw, { sheet: 1, schema }).then((rows) => {
        const groupedByNames = rows.rows.reduce(function (r, a) {
            r[a.name] = r[a.name] || {};
            if (!r[a.name].items) r[a.name].items = []
            r[a.name].items.push(a);
            r[a.name].name = a.name
            r[a.name].category = a.category
            r[a.name].subCategory = a.subCategory
            r[a.name].lowalertquantity = a.lowalertquantity
            r[a.name].barcode = a.barcode
            return r;
        }, Object.create(null));

        console.log('rows',rows, this.shops, groupedByNames)
        // for (const key in groupedByNames) {
        //   const row = groupedByNames[key]
        //   console.log("row",row)
        // }
        for (const key in groupedByNames) {
          const row = groupedByNames[key]
          const priceList = this.$store.state.stores.map((store) => {
            // for now only working for single store
            return groupedByNames[key].items.map(rec => {
              return {
                serial: rec.serial,
                purcPr: rec.cost,
                sellPr: rec.price,
                quantity: rec.quantity,
                store: store.id,
              };
            })
            
          })
          console.log('row',row)
          this.$store.state.secondaryDatabase
              .collection("products")
              .add({
                name: row.name,
                cat: row.category,
                subcat: row.subCategory,
                loc: this.shops[0].loc,
                sname: this.shops[0].shopname,
                price: 0,
                dis: 0,
                disprice: 0,
                barcode: row.barcode,
                altertQunty: row.lowalertquantity,
                
                profitMargin: 0,
                priceList: priceList[0], // bcz it returns array inside array
                variations: [],
                colors: [],
                expireDate: '',
                brand: '',
                rack: '',
                color: '',
                cond: '',
                type: '',
                war: '',
                desc: '',
                img: "data:image/jpeg;base64,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",
                otherimgs: [],
                owner: firebase.auth().currentUser.uid,
                shopID: this.shops[0].id,
                details: {
                  model: '',
                  karat: '',
                  metal: '',
                  author: '',
                  publisher: '',
                  size: '',
                  screensize: '',
                  material: '',
                },
                
              })
              .then((docRef) => {
                console.log('this.$store.state.prdNameList',this.$store.state.prdNameList)
                this.$store.state.prdNameList.push({
                  name: row.name,
                  barcode: row.barcode,
                });
                let prds = 'prds';
                if(this.$store.state.noDB === true) {
                  prds = `prds${firebase.auth().currentUser.uid}`
                } 
                this.$store.state.secondaryDatabase
                  .collection("prdlist")
                  .doc(prds)
                  .set({ data: this.$store.state.prdNameList })
                  .then((doc) => {})
                  .catch((error) => {
                    alert(error);
                  });

                //console.log('# items are', this.shops[0].categories[this.category][this.formdata.subcategory])
                if (!this.shops[0].categories[row.category]){
                  this.shops[0].categories[row.category] = {}
                } 
                if (!this.shops[0].categories[row.category][row.subCategory]){
                  this.shops[0].categories[row.category][row.subCategory] = 0
                } 
                if (!this.shops[0].catValues[row.category]) this.shops[0].catValues[row.category] = 0
                this.shops[0].catValues[row.category] += 1;
                this.shops[0].categories[row.category][
                  row.subCategory
                ] += 1;
                this.shops[0].curProducts += 1;
               
                console.log('# updated items are', {categories: this.shops[0].categories,
                    curProducts: this.shops[0].curProducts,
                    catValues: this.shops[0].catValues,})
                this.$store.state.secondaryDatabase
                  .collection("shops")
                  .doc(this.shops[0].id)
                  .update({
                    categories: this.shops[0].categories,
                    curProducts: this.shops[0].curProducts,
                    catValues: this.shops[0].catValues,
                  })
                  .then((doc) => {
                    
                  }).catch((error) => console.log(error));
               
              })
              .catch((error) => console.log(error));
        // `rows` is an array of rows
        // each row being an array of cells.
        }
      })
    
      })
      
    },
    toggleDetails(){
      this.items.forEach( item => item._showDetails = !item._showDetails)
    },
    downloadPDF() {
      this.perPage = this.items.length
      this.$root.$emit('savePDFClicked')
      setTimeout( () => this.perPage = this.pageOptions[2], 2000)
      
    },
    callCSVDownload(downloadCSVMethod) {
      if (downloadCSVMethod === 'downloadCSV')
        this.downloadCSV()
      else if (downloadCSVMethod === 'downloadCSVCashFlow')
        this.downloadCSVCashFlow()
      else if (downloadCSVMethod === 'downloadCSVProducts')
        this.downloadCSVProducts()
    },

    downloadCSVCashFlow(){
      const itemsToSave = []
      this.items.forEach(item => {
        itemsToSave.push({ 
          start: item.start,
          end: item.end,
          open_Amount: item.open,
          close_Amount: item.close,
          sales: item.sales,
          addition: item.add,
          deduction: item.deduct,
          inRegister: item.inRegi,
          difference: item.diff,
          description: item.desc,
          updated: item.updated,
          createdBy: item.createdBy,
          updatedBy: item.updatedBy
        })
      })

      //console.log("dowld",this.items,data, products)
      const data = JSON.parse(JSON.stringify(itemsToSave));
      const date = new Date(this.month);
      const monthName = date.toLocaleString('default', { month: 'long' });
      const fileName = `cash-flows-${date.getFullYear()}-${monthName}`;
      exportFromJSON({ data, fileName, exportType })
      
    },

    downloadCSVProducts(){
      
      const productsToSaveAsCSV = []
      this.items.forEach(item => {
        // item.priceList.forEach(p => {
        //   p.invoiceNo = item.invoiceNo;
        //   p.date = item.date;
        // })
        const products = []
        products.push(...item.priceList)
        products.forEach(prd => {
        if (prd.quantity !== 0 && prd.sellPr !== 0) { // removing non related stores for products
          productsToSaveAsCSV.push({
          name: item.name,
          barcode: item.barcode,
          serialNo: prd.serial,
          store: this.$store.state.stores.find(store => store.id ==prd.store).name,
          category: item.category,
          subcategory: item.subcategory,
          cost: prd.purcPr,
          price: prd.sellPr,
          quantity: prd.quantity,
          // availableQnty: prd.availableQnty,
         })
        }
        
      })
      })
      
      productsToSaveAsCSV.sort(function(a, b) {
          return a.name.localeCompare(b.name)
      });

      const productsData = JSON.parse(JSON.stringify(productsToSaveAsCSV));
      //console.log("dowld",this.items,data)
      const date = new Date(this.month);
      const monthName = date.toLocaleString('default', { month: 'long' });
      const fileName = `products-${productsToSaveAsCSV[0].category}-${date.getFullYear()}-${monthName}`;
      
      exportFromJSON({ data:productsData, fileName, exportType })
    },

    downloadCSV(){
      const products = []
      const productsToSaveAsCSV = []
      this.items.forEach(item => {
        item.products.forEach(p => {
          p.invoiceNo = item.invoiceNo;
          p.date = item.date;
        })
        products.push(...item.products)
        delete item.products
        delete item.storeLocation
        delete item.cashier
      })
      products.forEach(prd => {
        productsToSaveAsCSV.push({
          name: prd.name,
          barcode: prd.barcode,
          serialNo: prd.serial,
          invoiceNo: prd.invoiceNo,
          date: prd.date,
          category: prd.category,
          subcategory: prd.subcategory,
          cost: prd.cost,
          price: prd.price,
          quantity: prd.quantity,
          subTotal: prd.subTotal,
          discount: prd.discount,
          profit: prd.profit,
          // availableQnty: prd.availableQnty,
        })
      })
      productsToSaveAsCSV.sort(function(a, b) {
          return a.name.localeCompare(b.name)
      });
      //console.log("dowld",this.items,data, products)
      const data = JSON.parse(JSON.stringify(this.items));
      const productsData = JSON.parse(JSON.stringify(productsToSaveAsCSV));
      //console.log("dowld",this.items,data)
      const date = new Date(this.month);
      const monthName = date.toLocaleString('default', { month: 'long' });
      const fileName = `invoices-${date.getFullYear()}-${monthName}`;
      const productFileName = `products-sold-${date.getFullYear()}-${monthName}`;
      exportFromJSON({ data, fileName, exportType })
      exportFromJSON({ data:productsData, fileName:productFileName, exportType })
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/admin/TableHeader.vue